import { useEffect, useRef, useState } from "react";
import * as Functions from "../../functions/functions";
import { useIntl } from "react-intl";

// Fetch address from lat/lng using Dataforsyningen
export const getAddressFromCoords = async (lat, lng) => {
  try {
    const url = `https://api.dataforsyningen.dk/adgangsadresser/reverse?x=${lng}&y=${lat}&struktur=mini`;
    const res = await fetch(url);
    const data = await res.json();
    let address = "";
    sessionStorage.setItem("longitude", lng);
    sessionStorage.setItem("latitude", lat);
    if (data.type !== "QueryParameterFormatError") {
      address = data.betegnelse;
    }
    sessionStorage.setItem("currentAddress", address);
    return address;
  } catch (error) {
    console.error("Reverse geocoding error:", error);
    return "";
  }
};

const DanishAutoComplete = ({
  onPlaceSelected,
  inputValue,
  setInputValue,
  isProfile,
  setInvalidAddress,
  invalidAddress,
}) => {
  const [suggestions, setSuggestions] = useState([]);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const inputRef = useRef(null);
  const intl = useIntl();
  // Load current location and fetch address
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        const { latitude, longitude } = position.coords;
        if (!isProfile || inputValue === "") {
          const address = await getAddressFromCoords(latitude, longitude);
          if (address) {
            setInputValue(address);
          }
        }
      });
    }
  }, []);

  // Fetch suggestions as user types
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      const fetchSuggestions = async () => {
        if (inputValue.length < 2) {
          setSuggestions([]);
          return;
        }

        try {
          const data = await Functions.fetchDanishSuggestions(inputValue);
          if (
            data.length !== 0 &&
            data.some((item) => item.forslagstekst === inputValue)
          ) {
            setSuggestions([]);
            onPlaceSelected?.(data[0]);
          } else {
            setSuggestions(data);
          }

          if (invalidAddress && data.length > 0) {
            setInvalidAddress(false);
          }

          setHighlightedIndex(-1);
        } catch (err) {
          console.error("Autocomplete error:", err);
        }
      };

      fetchSuggestions();
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [inputValue]);

  const handleSelect = (suggestion) => {
    const text = suggestion.forslagstekst;
    setInputValue(text);
    setSuggestions([]);
    if (suggestion.data.x && suggestion.data.y) {
      sessionStorage.setItem("longitude", suggestion.data.x);
      sessionStorage.setItem("latitude", suggestion.data.y);
    }
  };

  const handleKeyDown = (e) => {
    if (suggestions.length === 0) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        prev < suggestions.length - 1 ? prev + 1 : 0
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        prev > 0 ? prev - 1 : suggestions.length - 1
      );
    } else if (e.key === "Enter" || e.key === "Tab") {
      if (highlightedIndex >= 0 && highlightedIndex < suggestions.length) {
        e.preventDefault();
        handleSelect(suggestions[highlightedIndex]);
      }
    }
  };

  return (
    <div style={{ position: "relative", justifyItems: "center" }}>
      <input
        ref={inputRef}
        type="text"
        value={inputValue}
        onKeyDown={handleKeyDown}
        onChange={(e) => setInputValue(e.target.value)}
        className="row-Search form-control"
        placeholder={
          isProfile ? intl.formatMessage({ id: "EnterHomeAddress" }) : ""
        }
        id="AddressId"
        autoComplete="off"
      />
      {suggestions.length > 0 && (
        <ul
          style={{
            position: "absolute",
            top: "100%",
            width: "80%",
            right: "10%",
            background: "#fff",
            border: "1px solid #ccc",
            zIndex: 1000,
            maxHeight: "200px",
            overflowY: "auto",
            margin: 0,
            padding: 0,
            listStyle: "none",
          }}
        >
          {suggestions.map((sug, idx) => (
            <li
              key={idx}
              onClick={() => handleSelect(sug)}
              style={{
                padding: "8px",
                cursor: "pointer",
                background: idx === highlightedIndex ? "#f0f0f0" : "#fff",
                borderBottom: "1px solid #eee",
              }}
            >
              {sug.forslagstekst}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DanishAutoComplete;
